import { render, staticRenderFns } from "./excel-button.component.vue?vue&type=template&id=f32c1e70&scoped=true"
import script from "./excel-button.component.vue?vue&type=script&lang=js"
export * from "./excel-button.component.vue?vue&type=script&lang=js"
import style0 from "./excel-button.component.vue?vue&type=style&index=0&id=f32c1e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32c1e70",
  null
  
)

export default component.exports